import { render, staticRenderFns } from "./ProductReviews.vue?vue&type=template&id=168e6dd7&"
import script from "./ProductReviews.vue?vue&type=script&lang=js&"
export * from "./ProductReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\laravel\\rawal\\rawal-laravel\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('168e6dd7')) {
      api.createRecord('168e6dd7', component.options)
    } else {
      api.reload('168e6dd7', component.options)
    }
    module.hot.accept("./ProductReviews.vue?vue&type=template&id=168e6dd7&", function () {
      api.rerender('168e6dd7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/ProductReviews.vue"
export default component.exports